import React from 'react';
import {Flex, SVGButton} from '/app/src/component';

const btnStyle = {
    bg: 'JibberBlue_M',
    height: '40px',
    color: 'white'
}

const fineTextContainer = {
    position: 'relative'
}

const fineTextBottomStyle = {
    position: 'absolute',
    top: '5px',
    fontSize: '11px',
    color: 'MediumGray6',
    hAlignContent: 'center',
    width: '100%'
}

const fineTextTopStyle = {
    position: 'absolute',
    bottom: '5px',
    fontSize: '11px',
    color: 'MediumGray6',
    textAlign: 'center',
    width: '150%',
    left: '-35px' //Magic number to align center
}

class NextBtn extends React.Component {
    render() {
        const {text, onClick, src, iconPos, fineText, top} = this.props
        return (
            <Flex column>
                {top && <Flex {...fineTextContainer}>
                    <Flex {...fineTextTopStyle}>
                        {fineText}
                    </Flex>
                </Flex>}
                <SVGButton
                    {...btnStyle}
                    onClick={onClick}
                    text={text}
                    src={src}
                    iconPos={iconPos} />
                    {!top && <Flex {...fineTextContainer}>
                        <Flex {...fineTextBottomStyle}>
                            {fineText}
                        </Flex>
                    </Flex>}
            </Flex>
        )
    }
}

export default NextBtn;



// WEBPACK FOOTER //
// ./src/component/Modal/PaymentModal/NextBtn.js